/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /* MARCA | 06/05/2026 | Increased max from 4 to 10 to support recently viewed tab carousel */
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 10;

  /**
   * MARCA | 26/05/2026 | Extended to accept optional badge data for custom badge rendering in recently viewed cards
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} [productHandle] - The URL handle of the product.
   * @param {{ text: string, bg: string, color: string } | null} [badge] - Optional custom badge data.
   */
  static addProduct(productId, productHandle, badge) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (/** @type {{ id: string, handle: string } | string} */ entry) => {
        const id = typeof entry === 'string' ? entry : entry.id;
        return id !== productId;
      }
    );

    /** @type {{ id: string, handle: string, badge?: { text: string, bg: string, color: string } | null }} */
    const entry = { id: productId, handle: productHandle || '' };
    if (badge && badge.text) entry.badge = badge;
    viewedProducts.unshift(entry);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * MARCA | 06/05/2026 | Returns normalised objects, with backward compatibility for legacy string entries
   * Retrieves the list of recently viewed products from localStorage.
   * @returns {{ id: string, handle: string }[]} The list of viewed products.
   */
  static getProducts() {
    const raw = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    return raw.map((/** @type {{ id: string, handle: string } | string} */ entry) =>
      typeof entry === 'string' ? { id: entry, handle: '' } : entry
    );
  }
}
